import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFocusInputFunctionality } from 'core/hooks';
import { useStepsContext } from 'core/states';
import { corporateUserService } from 'corporate/services';
import { ICorporateUserAutocomplete } from 'corporate/types';
import {
  AddBomPartsToQuoteStep,
  useAddBomPartsToQuoteContext,
} from 'quotes/components/AddBomPartsToQuote';
import { QuoteEntityType, QuoteType } from 'quotes/enums';

interface IProps {
  entityType?: QuoteEntityType;
  addToQuoteType: QuoteType;
}

export const SelectContact = ({
  entityType = QuoteEntityType.QUOTE,
  addToQuoteType = QuoteType.CUSTOMER,
}: IProps) => {
  const { t } = useTranslation();

  const { activeStep } = useStepsContext();
  const { selectedContact, setSelectedContact } = useAddBomPartsToQuoteContext();
  const { setFocusElementName } = useFocusInputFunctionality();

  useEffect(() => {
    if (activeStep.type === AddBomPartsToQuoteStep.SELECT_CONTACT) {
      setFocusElementName('contact');
    }
  }, [setFocusElementName, activeStep.type]);

  const contactLabel =
    QuoteType.CUSTOMER === addToQuoteType
      ? t('labelCustomerQuoteCustomer')
      : t('labelVendorQuoteContact', { entityType });

  return (
    <FormField
      name="contact"
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        label: contactLabel,
        getOptions: corporateUserService.getCorporateForeignUsersAutocomplete,
        requestPayload: {
          filters: {
            userType: addToQuoteType,
          },
        },
        getLabel: (option: ICorporateUserAutocomplete) => `${option.name} (${option.companyName})`,
        required: true,
        value: selectedContact,
        onChange: (_, option: ICorporateUserAutocomplete) => setSelectedContact(option),
      }}
    />
  );
};
